import React from 'react'
import { connect } from 'react-redux'
import { compose } from 'redux'
import Toolbar from '../../views/listview/Toolbar'
import Text from '../../views/typo/Text'
import { addLink } from '../../../actions/portal'

class LinkListToolbar extends React.Component {
  linksCount = () => (this.props.links ? this.props.links.length : undefined)

  render() {
    const imagesCount = this.linksCount()
    return (
      <Toolbar onAdd={this.props.onAddLink}>
        <Text className="subtitle">
          <strong>{imagesCount ? imagesCount : 'No'}</strong> Items
        </Text>
      </Toolbar>
    )
  }
}

export default compose(
  connect(
    ({ portal }) => ({
      portalId: portal._id,
      links: portal.links,
    }),
    {
      addLink,
    },
  ),
)(LinkListToolbar)



// WEBPACK FOOTER //
// ./src/components/templates/link-list/LinkListToolbar.js